import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationItemSelect',
  props: {
  value: { type: Object as PropType<any | null>, required: true },
  label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  items: { type: Object as PropType<Array<any>>, required: true },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const updateValue = (s: Object) => {
  emit('input', s);
};


return { __sfc: true,props, emit, updateValue }
}

})